export const isModalActive = state => key => !!state.activeModals[key];

export const isAnyModalActive = state => Object.keys(state.activeModals).length > 0;

export const modalContext = state => key => (state.activeModals[key] ? state.activeModals[key] : {});

export const appConfigs = state => state.appConfigs;
